var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2477,
    cy: 23.0353,
    r: 21.8229,
    fill: "#FBD806"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1645 31.6405L15.8839 11.123C15.0123 10.2826 13.5757 10.3575 12.6765 11.2901L11.7264 12.2755C10.8272 13.2081 10.8048 14.6466 11.6765 15.4869L32.9571 36.0045C33.8287 36.8449 35.2654 36.77 36.1645 35.8374L37.1146 34.852C38.0138 33.9194 38.0362 32.4809 37.1645 31.6405Z",
    fill: "#454545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4868 36.3234L36.0044 15.0428C36.8447 14.1712 36.7699 12.7346 35.8373 11.8354L34.8519 10.8853C33.9192 9.98611 32.4808 9.96375 31.6404 10.8354L11.1229 32.1159C10.2825 32.9876 10.3574 34.4242 11.29 35.3234L12.2754 36.2735C13.208 37.1727 14.6465 37.195 15.4868 36.3234Z",
    fill: "#454545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.1082a2d1a7e42c2dec1188b332383774.svg";
export { ForwardRef as ReactComponent };